module.exports = __webpack_public_path__ + "static/media/menu-homepage.4d22efed.svg";